import {
  SET_TOOL_CONFIG,
  MOUNT_LAYER_SETTINGS,
  OPEN_NOTES,
  SET_TOOL_VISIBLE,
  SET_TOOL_COLLAPSED,
  SET_TOOL_POSITION,
  SET_LAYER_SETTINGS_LAYER,
  SET_GROUP_SETTINGS_GROUP,
  SET_MAPVIEW_SETTINGS_GROUP,
  SET_DRAW_TARGET_LAYER,
  CLOSE_LAYER_SETTINGS,
  CLOSE_GROUP_SETTINGS,
  INITIALIZE_TOOLS_STATE,
} from '../actions/types'
import { normalizeToolConfig } from './reducer_tools_normalized'
import { defaultToolConfig } from '@/config/toolConfig'

/**
 * ToolReducer - Handles normalized ToolsState format only
 * Legacy array format support has been removed.
 */
export default function ToolReducer(state = null, action) {
  switch (action.type) {
    case SET_TOOL_CONFIG: {
      // Ensure payload is normalized format
      if (action.payload && typeof action.payload === 'object' && 'tools' in action.payload) {
        return action.payload
      }
      // If invalid format, initialize from default
      return {
        tools: normalizeToolConfig(defaultToolConfig),
      }
    }

    case INITIALIZE_TOOLS_STATE: {
      return {
        tools: normalizeToolConfig(defaultToolConfig),
      }
    }

    case SET_TOOL_VISIBLE: {
      const { toolName, visible } = action.payload
      if (!state?.tools) return state
      const tool = state.tools[toolName]
      if (!tool) return state
      return {
        tools: {
          ...state.tools,
          [toolName]: { ...tool, visible },
        },
      }
    }

    case SET_TOOL_COLLAPSED: {
      const { toolName, collapsed } = action.payload
      if (!state?.tools) return state
      const tool = state.tools[toolName]
      if (!tool || !('collapsed' in tool)) return state
      return {
        tools: {
          ...state.tools,
          [toolName]: { ...tool, collapsed },
        },
      }
    }

    case SET_TOOL_POSITION: {
      const { toolName, positionX, positionY } = action.payload
      if (!state?.tools) return state
      const tool = state.tools[toolName]
      if (!tool) return state

      // Only update position if tool supports it
      const updatedTool = { ...tool }
      if ('positionX' in updatedTool) {
        updatedTool.positionX = positionX ?? updatedTool.positionX
      }
      if ('positionY' in updatedTool) {
        updatedTool.positionY = positionY ?? updatedTool.positionY
      }

      return {
        tools: {
          ...state.tools,
          [toolName]: updatedTool,
        },
      }
    }

    case SET_LAYER_SETTINGS_LAYER: {
      const { layer } = action.payload
      if (!state?.tools) return state
      const tool = state.tools.LayerSettings
      if (!tool || tool.name !== 'LayerSettings') return state
      return {
        tools: {
          ...state.tools,
          LayerSettings: { ...tool, layer, visible: layer !== null },
        },
      }
    }

    case CLOSE_LAYER_SETTINGS: {
      if (!state?.tools) return state
      const tool = state.tools.LayerSettings
      if (!tool || tool.name !== 'LayerSettings') return state
      return {
        tools: {
          ...state.tools,
          LayerSettings: { ...tool, visible: false, layer: null },
        },
      }
    }

    case SET_GROUP_SETTINGS_GROUP: {
      const { group } = action.payload
      if (!state?.tools) return state
      const tool = state.tools.GroupSettings
      if (!tool || tool.name !== 'GroupSettings') return state
      return {
        tools: {
          ...state.tools,
          GroupSettings: { ...tool, group, visible: group !== null },
        },
      }
    }

    case CLOSE_GROUP_SETTINGS: {
      if (!state?.tools) return state
      const tool = state.tools.GroupSettings
      if (!tool || tool.name !== 'GroupSettings') return state
      return {
        tools: {
          ...state.tools,
          GroupSettings: { ...tool, visible: false, group: null },
        },
      }
    }

    case SET_MAPVIEW_SETTINGS_GROUP: {
      const { mapViewGroup } = action.payload
      if (!state?.tools) return state
      const tool = state.tools.MapViewSettings
      if (!tool || tool.name !== 'MapViewSettings') return state
      return {
        tools: {
          ...state.tools,
          MapViewSettings: { ...tool, mapViewGroup, visible: mapViewGroup !== null },
        },
      }
    }

    case SET_DRAW_TARGET_LAYER: {
      const { targetLayer } = action.payload
      if (!state?.tools) return state
      const tool = state.tools.Draw
      if (!tool || tool.name !== 'Draw') return state
      return {
        tools: {
          ...state.tools,
          Draw: {
            ...tool,
            targetLayer,
          },
        },
      }
    }

    default:
      return state
  }
}

export function MountLayerSettings(state = 1, action) {
  switch (action.type) {
    case MOUNT_LAYER_SETTINGS: {
      return action.payload
    }
    default:
      return state
  }
}

export function OpenNotes(state = null, action) {
  switch (action.type) {
    case OPEN_NOTES: {
      return action.payload
    }
    default:
      return state
  }
}
